<template>
    <v-layout justify-center>
        <v-dialog v-model="show" persistent width="700px">
            <v-toolbar dark color="blue lighten-2">
                <v-btn icon dark @click="show = false">
                    <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>{{promoModel.title}}</v-toolbar-title>
                <v-toolbar-title>{{order.title}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="save" :disabled="!valid">
                        <v-icon>save</v-icon>
                        {{promoModel.id === null ? ' Создать' : ' Сохранить'}}
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-list subheader class="content">
                <v-container>
                    <v-row>
                        <v-form
                                ref="form"
                                v-model="valid"
                        >
                            <v-col cols="12">
                                    <v-text-field
                                            v-model="promoModel.title"
                                            label="Название"
                                            :rules="[rules.required,rules.maxLengthTitle]"
                                    />
                                    <v-text-field
                                            v-model="promoModel.code"
                                            label="Промокод"
                                            :rules="[rules.required,rules.maxLengthCode]"
                                    />
                                    <v-btn color="primary" @click="generatePromo">Сгенерировать промокод</v-btn>
                                    <v-select
                                            hide-details
                                            :items="statusesForThis"
                                            v-model="promoModel.status"
                                            label="Статус"
                                    />
                                    <v-text-field
                                            v-model="promoModel.min_price"
                                            label="Минимальная сумма заказа"
                                            :rules="[rules.required]"
                                            type="number"
                                    />
                                    <v-text-field
                                            v-model="promoModel.count"
                                            label="Количество купонов всего"
                                            :rules="[rules.required]"
                                    />
                                    <v-text-field
                                            v-model="promoModel.count_for_client"
                                            label="Количество купонов на одного клиента"
                                            :rules="[rules.required]"
                                    />
                                    <v-select
                                            hide-details
                                            :items="[ { value: 1, text: 'Скидка в валюте' }, { value: 2, text: 'Скидка в процентах' } ]"
                                            v-model="promoModel.sale_for"
                                            label="Скидка в:"
                                    />
                                    <v-text-field
                                            v-model="promoModel.sale_size"
                                            label="Размер скидки"
                                            :rules="[rules.required]"
                                    />
                                    <v-select
                                            hide-details
                                            :items="typesForThis"
                                            v-model="promoModel.type"
                                            label="Тип скидки"
                                    />
                            </v-col>
                        </v-form>
                    </v-row>
                </v-container>
            </v-list>
        </v-dialog>

        <v-snackbar
                v-model="snackbarParams.show"
                bottom
                :color="snackbarParams.color"
                right
        >
            {{snackbarParams.text}}
            <v-btn
                    dark
                    text
                    @click="snackbarParams.show = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
    </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import timeHelpers from '../../../scripts/helpers/timeHelpers'
import constConf from '../../../constconf'
export default {
    name: 'PromoForm',
    components: {
    },
    props: ['promoFormShow', 'promoId', 'statuses', 'types'],
    data() {
        return {
            show: false,
            snackbarParams: {
                show: false,
                color: 'success',
                text: 'Успешно сохранено!'
            },
            promoModel: {
                id: null,
                bot_id: null,
                title: '',
                code: '',
                status: 1,
                type: 1,
                created_at: null,
                min_price: 0,
                count: 0,
                count_for_client: 0,
                sale_for: 1,
                sale_size: 0
            },
            promoModelDef: {
                id: null,
                bot_id: null,
                title: '',
                code: '',
                status: 1,
                type: 1,
                created_at: null,
                min_price: 0,
                count: 0,
                count_for_client: 0,
                sale_for: 1,
                sale_size: 0
            },
            ...constConf,
            valid: true,
            rules: {
                required: value => !!value || 'Обязательное поле.',
                maxLengthTitle: value => (value.length <= 255) || 'Максимальная длина названия 255 символов.',
                maxLengthCode: value => (value.length <= 20) || 'Максимальная длина промокода 20 символов.'
            }
        }
    },
    watch: {
        promoFormShow: {
            handler(value) {
                if (value) {
                    this.loadModel()
                    this.show = value
                    if (this.$route.path !== '/bot' + this.$route.params['pathMatch'] + '/promo/' + this.promoId && this.promoId != null) {
                        this.$router.push({ path: '/bot' + this.$route.params['pathMatch'] + '/promo/' + this.promoId })
                    }
                } else {
                    if (this.$route.path !== '/bot' + this.$route.params.pathMatch + '/promo') {
                        this.$router.push({ path: '/bot' + this.$route.params.pathMatch + '/promo' })
                    }
                }
            },
            deep: false,
            immediate: false
        },
        show(value) {
            if (!value) {
                this.$refs.form.resetValidation()
                this.$emit('close')
            }
        }
    },
    methods: {
        save() {
            this.$store.dispatch('cards/promoSave', this.promoModel).then(response => {
                if (response.ok) {
                    this.snackbarParams.text = 'Успешно сохранено!'
                    this.snackbarParams.color = 'success'
                    this.snackbar = true
                }
            })
        },
        loadModel() {
            let promo
            if (this.promoId != null) {
                promo = this.getPromoById(this.promoId)
            } else {
                promo = this.promoModelDef
            }
            this.promoModel = Object.assign({}, promo)
            this.promoModel.min_price = '' + promo.min_price
            this.promoModel.count = '' + promo.count
            this.promoModel.count_for_client = '' + promo.count_for_client
            this.promoModel.sale_size = '' + promo.sale_size
        },
        ...timeHelpers,
        generatePromo() {
            let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ123456789'
            let text = ''

            for (let i = 0; i < 8; i++) {
                text += possible.charAt(Math.floor(Math.random() * possible.length))
            }
            this.promoModel.code = text
        }
    },
    computed: {
        ...mapGetters({
            order: 'cards/getOrderById',
            getClientByUserId: 'clients/getClientByUserId',
            getPromoById: 'cards/getPromoById',
            clients: 'clients/clients'
        }),
        statusesForThis() {
            let statuses = this.statuses.slice()
            statuses.splice(0, 1)
            return statuses
        },
        typesForThis() {
            let types = this.types.slice()
            types.splice(0, 1)
            return types
        }
    },
    created() {
        this.loadModel()
        this.promoModelDef.bot_id = +this.$route.params['pathMatch']
    }
}
</script>

<style scoped lang="scss">
    ::-webkit-scrollbar {
        width: $width-scroll-panel;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $light;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $blue-active;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $blue-inactive;
    }

    .container {
        height: 70vh;
        display: flex;
        flex-direction: column;
    }
</style>
